import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {AuthService} from "../services/auth.service";

export const authGovbrGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticatedGovBr()) {
    return true; // Permite o acesso à rota
  } else {
    // Redireciona para a página principal
    router.navigate(['/']).then(() => console.log("redirected to home"));
    return false;
  }
};
